import { render, staticRenderFns } from "./KeyPal.vue?vue&type=template&id=0c1ab078&scoped=true"
import script from "./KeyPal.vue?vue&type=script&lang=js"
export * from "./KeyPal.vue?vue&type=script&lang=js"
import style0 from "./KeyPal.vue?vue&type=style&index=0&id=0c1ab078&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c1ab078",
  null
  
)

export default component.exports